module.exports = __webpack_public_path__ + "media/images/thumbs/biology/v_qv_red_blood_cells_and_platelets_1-11272e7070667731c41b8cb02fde0c2c.jpg";